import React from 'react';
import { useSelector } from 'react-redux';

import CancelSessionButton from './CancelSessionButton/CancelSessionButton';
import SendReminderButton from './SendReminderButton/SendReminderButton';
import { HeaderTestID } from './constants';
import { formatSessionTimeForDisplay, getMonthAndDayFromSessionStartTime } from './helpers';
import { SessionDetails } from '../../ScheduleSessionForm/constants';
import CalendarIcon from './CalendarIcon/CalendarIcon';
import { getCurrentUser } from '../../../../../selectors/userSelectors';

export interface Props {
  isCanceling: boolean;
  isSubmitting: boolean;
  onCancelSession: () => void;
  onSendReminder: () => void;
  sessionDetails: SessionDetails;
}

const SendReminder: React.FC<Props> = ({
  children,
  isCanceling,
  isSubmitting,
  onCancelSession,
  onSendReminder,
  sessionDetails,
}) => {
  const user = useSelector(getCurrentUser);

  return (
    <>
      <div className="mb-6 flex justify-center">
        <CalendarIcon {...getMonthAndDayFromSessionStartTime(sessionDetails.startTime)} />
      </div>

      <div className="font-gray-700 text-2xl mb-4 font-bold" data-testid={HeaderTestID}>
        Reserve session and send reminder
      </div>

      <div className="mb-4 flex justify-center text-gray-600 text-base font-bold">
        {formatSessionTimeForDisplay({
          endTime: sessionDetails.endTime,
          startTime: sessionDetails.startTime,
          user,
        })}
      </div>

      {children}

      <div className="flex justify-center">
        <CancelSessionButton
          className="mr-1"
          isInProgress={isCanceling || isSubmitting}
          onClick={onCancelSession}
        />

        <SendReminderButton
          className="ml-1"
          isInProgress={isCanceling || isSubmitting}
          onClick={onSendReminder}
        />
      </div>
    </>
  );
};

export default SendReminder;
